export const MIN_APPLICATION_TYPED_CHARS = 100;

const MARKDOWN_IMAGE_RE = /!\[[^\]]*\]\([^)]+\)/g;
const MARKDOWN_LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;
const RAW_URL_RE = /<?https?:\/\/[^\s<>[\]()'"]+>?/gi;
const WWW_URL_RE = /<?\bwww\.[^\s<>[\]()'"]+>?/gi;
const PORTFOLIO_HEADING_RE =
  /\*{0,2}(?:Related Projects|Attached links):\*{0,2}/gi;

/**
 * Remove portfolio headings and URLs so only typed free-text remains.
 * Markdown link labels are kept; the URL target is discarded.
 * Line breaks are not kept — they must not pad the character minimum.
 *
 * @param {string} text
 * @returns {string}
 */
export function stripNonTypedApplicationContent(text) {
  if (!text) {
    return '';
  }

  let result = String(text);

  result = result.replace(MARKDOWN_IMAGE_RE, ' ');
  result = result.replace(MARKDOWN_LINK_RE, '$1');
  result = result.replace(RAW_URL_RE, ' ');
  result = result.replace(WWW_URL_RE, ' ');
  result = result.replace(PORTFOLIO_HEADING_RE, ' ');

  return result
    .split(/\r\n|\r|\n/)
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .join('');
}

/**
 * Character count that should be used for the application minimum.
 *
 * @param {string} text
 * @returns {number}
 */
export function getTypedApplicationCharacterCount(text) {
  return stripNonTypedApplicationContent(text).length;
}

/**
 * Whether the application has enough typed content to submit.
 *
 * @param {string} text
 * @param {number} min
 * @returns {boolean}
 */
export function hasMinimumTypedApplicationContent(
  text,
  min = MIN_APPLICATION_TYPED_CHARS
) {
  return getTypedApplicationCharacterCount(text) >= min;
}
